module.exports = __webpack_public_path__ + "static/logoFundoPreto-e4246784e9407395b52c262f484e729d.png";